/**
 * The slug the API will derive from a party name — kept in step with `slugify`
 * in `apps/api/src/repository/party.ts` so the create form can say whether a
 * name is usable while it is still being typed.
 */
export const partySlugOf = (name: string): string =>
  name
    .trim()
    .toLowerCase()
    .replaceAll(/[^a-z0-9]+/gu, '-')
    .split('-')
    .filter((segment) => segment !== '')
    .join('-');
